module.exports = __webpack_public_path__ + "static/media/IconModalOrcamentoAtividade.d46e7390.svg";